<mat-stepper linear #stepper>
  <mat-step [stepControl]="setupForm" [formGroup]="setupForm" [editable]="true">
    <ng-template matStepLabel>Content</ng-template>

    <div class="setup-intro">
      <p>
        Use this tile to connect a datasource to a map view. The title labels the tile and the
        datasource determines which locations or entries are rendered.
      </p>
    </div>

    <div class="inputs-container">
      <mat-form-field appearance="fill">
        <mat-label>Title</mat-label>
        <input matInput formControlName="title" />
        <mat-hint>Sets the heading shown above the map tile.</mat-hint>
        <mat-error *ngIf="titleControl.hasError('required')">Title is required</mat-error>
      </mat-form-field>

      <app-data-source-selector
        formControlName="dataSource"
        hint="Chooses which datasource supplies the entries shown on the map."
        (onDataSourceChange)="initDataSource($event)"
      ></app-data-source-selector>
    </div>

    <div>
      <button mat-button matStepperNext (click)="setupForm.markAllAsTouched()">Next</button>
    </div>
  </mat-step>
  <mat-step>
    <ng-template matStepLabel>Confirm</ng-template>
    <p>Title: {{ titleControl.value }}</p>
    <p>Data Source: {{ dataSourceObject?.name }}</p>
    <div>
      <button mat-button matStepperPrevious>Back</button>
      <button mat-button (click)="onCreate()">Apply</button>
    </div>
  </mat-step>
</mat-stepper>
